import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit} from '@angular/core';
import {notificationAnimation} from '@ngx-notifications/notifications.animations';
import {NgxNotification} from '@ngx-notifications/notifications.interface';
import {NgxNotifications} from '@ngx-notifications/notifications.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Observable} from 'rxjs';

@Component({
    selector: 'ngx-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    animations: [notificationAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgxNotificationsList implements OnInit {

    @Input() align = 'top right';
    @Input() maxWidth = '360px';

    notifications$: Observable<NgxNotification[]>;

    trackById = (index: number, item: NgxNotification) => {
        return item.id;
    };

    @HostBinding('style.justify-content')
    get xAlignment() {
        const align = this.alignment;
        const xDirection = align.x;
        if (xDirection !== 'left' && xDirection !== 'right') {
            throw new Error(`The [x] can only be 'left' || 'right'.`);
        }
        return xDirection === 'left' ? 'flex-start' : 'flex-end';
    }

    @HostBinding('style.align-items')
    get yAlignment() {
        const align = this.alignment;
        const yDirection = align.y;
        if (yDirection !== 'top' && yDirection !== 'bottom') {
            throw new Error(`The [y] can only be 'top' || 'bottom'.`);
        }
        return yDirection === 'top' ? 'flex-start' : 'flex-end';
    }

    get params() {
        return {
            fromX: this.alignment.x === 'left' ? '-50%' : '50%',
            toX: '0'
        };
    }

    get alignment() {
        if (!this.align) {
            return {x: 'right', y: 'top'};
        }

        const directions = this.align.split(' ');

        if (directions.length !== 2) {
            throw new Error('The align variables must have an [y x] format.');
        }

        return {
            x: directions[1].trim(),
            y: directions[0].trim()
        };
    }

    constructor(private sanitizer: DomSanitizer,
                private notifications: NgxNotifications) {
    }

    ngOnInit() {
        this.notifications$ = this.notifications.items;
    }

}
